"use strict";var e=require("./chakra-ui-system.esm-434904f8.js");exports.useTheme=()=>e.useTheme();
//# sourceMappingURL=useTheme-ee73b181.js.map
